import request from "../utils/request"

export const getStandard = lessonId => request.get(`/questions/${lessonId}/standard`)
// The body is optional: { answer_state, reveal, reveal_delivery }, built by
// QuestionItem. With none, the request goes exactly as it always did.
export const toggleDone = (questionId, body) =>
	body === undefined
		? request.post(`/questions/${questionId}/toggle`)
		: request.post(`/questions/${questionId}/toggle`, body)
// Capture once, deliver silently with retry-safe identity and original click time.
// Returns the event ({ event_id, occurred_at }) synchronously, so the GOT IT can carry it.
export const logRevealAnswer = questionId => request.postRevealAnswer(questionId)
// { delivered, pending, refused_status, paused } for one event, as this page knows it.
export const revealAnswerDeliveryState = eventId => request.revealAnswerDeliveryState(eventId)
